import { PropsWithChildren } from 'react'

export function DuplicateCardGrid(props: PropsWithChildren) {
  return <div className="grid max-h-[400px] pr-2xs auto-rows-max grid-cols-2 gap-xl overflow-y-auto">{props.children}</div>
}
